import { useParams, withRouter } from 'react-router';

import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';

import MeasurementService from 'app/admin/measurement/service/MeasurementService';
import PiMeasurementReaderService from 'app/admin/piMeasurementReader/service/PiMeasurementReaderService';
import LabMeasurementReaderService from 'app/admin/labMeasurementReader/service/LabMeasurementReaderService';
import ModelValidationService from 'app/admin/modelValidation/service/ModelValidationService';
import OutlierDetectorService from 'app/admin/outlierDetector/service/OutlierDetectorService';
import UnitOptimizerService from 'app/admin/unitOptimizer/service/UnitOptimizerService';
import OptimizationPipelineLogService from 'app/admin/optimizationPipelineLog/service/OptimizationPipelineLogService';
import OptimizationPipelineEditService from '../service/OptimizationPipelineEditService';
import ShowOptimizationPipelineButton from 'app/admin/optimizationPipelineV2/component/ShowOptimizationPipelineButton';
import EdtDynamicCheckService from 'app/admin/edtDynamicCheck/service/EdtDynamicCheckService';
import PiWriterService from 'app/admin/piWriter/service/PiWriterService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';
import OpcDaWriterService from 'app/admin/opcDaWriter/service/OpcDaWriterService';

const config = data => {
	return {
		key: 'optimizationPipelineEditForm',
		topic: 'optimizationPipeline',
		service: OptimizationPipelineEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'piMeasurementEntries' }, { key: 'labMeasurementEntries' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'mergedMeasurement',
					component: EditFormSelectField,
					required: true,
					items: () => MeasurementService.getListSelection()
				},
				{
					key: 'outlierDetectors',
					component: EditFormSelectField,
					required: true,
					multiple: true,
					items: () => OutlierDetectorService.getListSelection()
				},
				{
					key: 'cleanMeasurement',
					component: EditFormSelectField,
					required: true,
					items: () => MeasurementService.getListSelection()
				},
				{
					key: 'modelValidation',
					component: EditFormSelectField,
					required: true,
					items: () => ModelValidationService.getListSelection()
				},
				{
					key: 'unitOptimizer',
					component: EditFormSelectField,
					required: true,
					items: () => UnitOptimizerService.getListSelection()
				},
				{
					key: 'optimizationPipelineLog',
					component: EditFormSelectField,
					required: true,
					items: () => OptimizationPipelineLogService.getListSelection()
				},
				{
					key: 'edtDynamicCheck',
					component: EditFormSelectField,
					items: () => EdtDynamicCheckService.getListSelection()
				},
				{
					key: 'piWriter',
					component: EditFormSelectField,
					required: true,
					items: () => PiWriterService.getListSelection()
				},
				{
					key: 'opcDaWriter',
					component: EditFormSelectField,
					required: true,
					items: () => OpcDaWriterService.getListSelection()
				},
				{
					key: 'summaryDuration',
					component: EditFormTextField,
					required: true,
					type: 'number',
					integerOnly: true
				},
				{
					key: 'summaryDurationUnit',
					component: EditFormSelectField,
					required: false,
					type: 'enum',
					items: [
						{ label: 'Hour', value: 'HOUR' },
						{ label: 'Day', value: 'DAY' }
					]
				},
				{
					key: 'summaryType',
					component: EditFormSelectField,
					required: false,
					type: 'enum',
					items: [
						{ label: 'Total', value: 'TOTAL' },
						{ label: 'Average', value: 'AVERAGE' },
						{ label: 'Minimum', value: 'MINIMUM' },
						{ label: 'Maximum', value: 'MAXIMUM' }
					]
				},
				{
					key: 'piMeasurementEntries',
					tab: 'piMeasurementEntries',
					component: EditFormGridComponent,
					defaultValue: {
						optimizationPipeline: null,
						piMeasurementReader: null,
						measurement: null,
					},
					fields: [
						{
							key: 'piMeasurementReader',
							component: EditFormSelectField,
							required: true,
							items: () => PiMeasurementReaderService.getListSelection()
						},
						{
							key: 'measurement',
							component: EditFormSelectField,
							required: true,
							items: () => MeasurementService.getListSelection()
						},
					]
				},
				{
					key: 'labMeasurementEntries',
					tab: 'labMeasurementEntries',
					component: EditFormGridComponent,
					defaultValue: {
						labMeasurementReader: null,
						measurement: null,
					},
					fields: [
						{
							key: 'labMeasurementReader',
							component: EditFormSelectField,
							required: true,
							items: () => LabMeasurementReaderService.getListSelection()
						},
						{
							key: 'measurement',
							component: EditFormSelectField,
							required: true,
							items: () => MeasurementService.getListSelection()
						},
					]
				},
			];

			return fields;
		}
	};
};

function OptimizationPipelineEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	return (
		<EditFormPage config={myConfig} beforeSaveContent={
			<>
				<ShowOptimizationPipelineButton id={id} form />
			</>
		} />
	);
}

export default withRouter(OptimizationPipelineEditForm);